import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { actions } from '../ducks/twilio';
import { joinTwilioRoom } from '../../services/twilio';
import { select } from 'typed-redux-saga';
import TStore from 'types/store';

function* joinTwilioRoomRequest({ payload }: ReturnType<typeof actions.joinTwilioRoomRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);

    const { data } = yield* call(joinTwilioRoom, providerId, payload);
    const room = data.data.room;

    if (room) {
      yield* put(actions.joinTwilioRoomRequestSuccess(room));
    } else {
      yield* put(actions.joinTwilioRoomRequestError('eVisits_twilio_room_not_available'));
    }
  } catch (error) {
    console.log('joinTwilioRoomRequest error', error);
    yield* put(actions.joinTwilioRoomRequestError('eVisits_twilio_join_room_error'));
  }
}

function* EVisitsSaga() {
  yield takeLatest(actions.joinTwilioRoomRequest, joinTwilioRoomRequest);
}

export default EVisitsSaga;
